<template>
  <bizgain-component-layout
    :is-next-btn-enabled="true"
    :col-width="{
      'mx-5 px-4': !$vuetify.breakpoint.xsOnly,
      'mx-2': $vuetify.breakpoint.xsOnly
    }"
    :is-content-top="true"
    view-port-height="170px"
  >
    <template v-slot:heading>
      {{ $t('message.bizgainOnboarding.businessDetailsHeadingv2') }}
    </template>
    <template v-slot:content>
      <v-flex xs12 class="business-location-details">
        <v-flex :class="[{'d-flex': !$vuetify.breakpoint.xsOnly}]">
          <v-flex xs12 md6 v-if="!isInAppCampaign">
            <custom-text-field
              :placeholder="$tc('message.bizgainOnboarding.businessName')"
              :classes="['pt-0 mt-0',{'pr-2':!$vuetify.breakpoint.xsOnly}]"
              :name="'businessName'"
              :counter="'25'"
              v-model="businessName"
              :autocapitalize="'off'"
              :validation="'required|max:25|emojiValidation'"
              :icon="'mdi-check'"
            />
          </v-flex>
          <v-flex
            v-if="!isInAppCampaign"
            xs12
            md-5
            :class="[{'pl-2': !$vuetify.breakpoint.xsOnly, 'pt-3': $vuetify.breakpoint.xsOnly}]"
          >
            <business-type
              :is-summary="false"
              :hide-business-type-label="true"
              @save-businessType="updateBusinessType"
            />
          </v-flex>
        </v-flex>
        <v-flex xs12 :class="['business-type-services',{'pt-3':!isInAppCampaign}]">
          <ExtractOfferDetailsV2 @offerDetails="setOfferDetails" :promotion-copy="promotionCopy" :business-type="businessType" />
        </v-flex>
      </v-flex>
    </template>
    <template v-slot:btn-content>
      <v-flex xs12>
        <v-layout :class="{ 'column reverse': $vuetify.breakpoint.xsOnly }">
          <v-flex
            :class="{
              'shrink nxt-btn-margin mt-0': !$vuetify.breakpoint.xsOnly,
              xs12: $vuetify.breakpoint.xsOnly,
              'pl-2': $vuetify.breakpoint.smOnly
            }"
          >
            <v-btn
              depressed
              class="mx-0 w-100 next-btn-color primary-btn-xs"
              :loading="isLoading"
              :disabled="buttonDisabled || errors.items.length > 0"
              @click="updateUser"
            >
              {{ $t('message.bizgainOnboarding.createMyAds') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </template>
  </bizgain-component-layout>
</template>
<script>
import {
  VFlex,
  VBtn,
  VLayout
} from 'vuetify/lib';
import BizgainComponentLayout from 'Components/BizgainComponentLayout/BizgainComponentLayout.vue';
import { mapActions, mapGetters } from 'vuex';
import clearErrorByField from 'Mixins/clearErrorByField';
import {
  bizgainOnboardingRoutes,
  signupFlowSteps, onboardingSections, objectiveType, privacyPolicyDataAccessTypes, launchState, subsequentFlowSteps
} from 'Features/bizgainOnboarding/constants';
import { Chat } from 'Mixins/chat';
import Bugsnag from '@bugsnag/js';
import { Validator } from 'vee-validate';
import onboardingRedirect  from 'Mixins/onboardingRedirect';
import BusinessType from 'Components/BusinessType/BusinessType.vue';
import ExtractOfferDetailsV2 from '../../offerDetails/components/ExtractOfferDetailsV2.vue';
import { i18n } from '@/lang/';
import CustomTextField from '../../../../../components/Input/CustomTextField.vue';
import { ApiService } from 'Features/bizgainOnboarding/services/apiService';
const apiService = new ApiService();

export default {
  mixins: [clearErrorByField, Chat, onboardingRedirect],
  components: {
    VFlex,
    VBtn,
    VLayout,
    BizgainComponentLayout,
    BusinessType,
    ExtractOfferDetailsV2,
    CustomTextField
  },
  data() {
    return {
      businessName: null,
      bizgainOnboardingRoutes,
      businessType: null,
      formFields: [],
      privacyPolicyDataAccessTypes,
      offerDetail: null,
      isValidOfferDetails: false,
      isLoading: false,
      promotionCopy: null
    };
  },
  computed: {
    ...mapGetters([
      'currencySymbol',
      'region',
      'businessDetails',
      'isInAppCampaign',
      'businessProfileId',
      'roimaticCampaignId',
      'additionalConfiguration'
    ]),
    buttonDisabled(){
      if(this.isInAppCampaign){
        if(!this.isValidOfferDetails){
          return true;
        }
      }else{
        if(!this.businessType || !this.isValidOfferDetails || !this.businessName){
          return true;
        }
      }
      return false;
    }
  },
  async created() {
    if(!this.$route.query.agentid && localStorage.getItem('isAgentFlow')){
      localStorage.removeItem('isAgentFlow');
    }

    if(this.businessDetails && this.businessDetails.name){
      this.businessName = this.businessDetails.name
    }
    if(this.businessDetails && this.businessDetails.creativeDetail && this.businessDetails.creativeDetail.leadAdConfiguration){
      this.formFields = this.businessDetails.creativeDetail.leadAdConfiguration.formFields
    }
    const dict = {
      custom: {
        businessName: {
          max: this.$t(
            'message.bizgainOnboarding.businessNameValidationMessage'
          )
        }
      }
    };

    Validator.localize('en', dict);
    Validator.extend('emojiValidation', {
      getMessage: () =>
        this.$t('message.bizgainOnboarding.specialCharacterValidation'),
      validate: (value) => {
        return this.validateBusinessName(value);
      }
    });

    this.setCurrentSection(onboardingSections.signup);

    if(this.isInAppCampaign){
      this.setCurrentRoute(bizgainOnboardingRoutes.SubsequentBusinessDetailsV2.name);
      this.setSubsequentSteps(subsequentFlowSteps);
    }else{
      this.setCurrentRoute(bizgainOnboardingRoutes.BusinessDetailsV2.name);
      this.setSignUpSteps(signupFlowSteps);
    }
  },
  methods: {
    ...mapActions([
      'setCurrentRoute', 'getBusinessDetails',
      'setSignUpSteps',, 'setSubsequentSteps', 'patchAdditionalConfiguration',
      'setCurrentSection', 'setBusinessDetails', 'updateOfferDetails', 'creativeConfiguration', 'patchBusinessDetails', 'getBusinessDetails'
    ]),
    setFormFields(selectedFields){
      this.formFields = selectedFields;
    },
    setOfferDetails(offerDetails, isValidOfferDetails){
      this.isValidOfferDetails = isValidOfferDetails;
      this.offerDetail = offerDetails;
    },
    async updateUser() {
      this.isLoading = true;
      let isValid = await this.$validator.validate();
      if(isValid && this.region && !this.isInAppCampaign){
        try{
          await this.updateUserProperties({ businessName: this.businessType, businessType: this.businessType, objectiveType: i18n.tc(objectiveType.leadGeneration.conversionTitle) });
          if(!this.businessDetails){
            let payload = {
              name: this.businessName.trim(),
              category: { displayName: this.businessType.value.displayName },
              region: this.region,
              shortenFlow: true,
              queryParameters: this.$route.query
            }

            await this.setBusinessDetails(payload);
          }

          await this.goToNextPage();
        }
        catch(error){
          Bugsnag.notify(error);
          this.isLoading = false;
        }
      }
      else if(this.isInAppCampaign){
        try{
          await this.goToNextPage();
        }
        catch(error){
          Bugsnag.notify(error);
          this.isLoading = false;
        }
      }
    },
    async goToNextPage(){
      try{
        let creativeDetail = await apiService.creativeConfiguration({ sessionId: this.businessDetails.sessionId, objective: 2 });
        this.businessDetails.creativeDetail = creativeDetail;

        await this.updateOfferDetails({ businessDetails: this.businessDetails, offerDetail: this.offerDetail, sessionId: this.businessDetails.sessionId })
        let newBusinessDetails = JSON.parse(JSON.stringify(this.businessDetails));
        newBusinessDetails.creativeDetail.objective = 2;
        newBusinessDetails.launchState = launchState.BusinessDetailsSetupAnimationV2;
        newBusinessDetails.CurrencySymbol = this.currencySymbol;
        if(!this.isInAppCampaign){
          newBusinessDetails.name = this.businessName.trim();
          newBusinessDetails.category.displayName = this.businessType.value.displayName;
        }

        let dataTypes = []
        for (let dataType in this.privacyPolicyDataAccessTypes) {
          dataTypes.push(this.privacyPolicyDataAccessTypes[dataType].value);
        }

        if (newBusinessDetails.creativeDetail.leadAdConfiguration.hasOwnProperty('privacyPolicyConfiguration')){
          newBusinessDetails.creativeDetail.leadAdConfiguration.privacyPolicyConfiguration.dataAccessTypes = dataTypes;
        }
        else{
          newBusinessDetails.creativeDetail.leadAdConfiguration.privacyPolicyConfiguration = dataTypes;
        }

        if(this.offerDetail.service){
          newBusinessDetails.creativeDetail.promoteServices = [this.offerDetail.service];
          newBusinessDetails.services = [this.offerDetail.service];
        }
        else{
          if(this.isInAppCampaign){
            newBusinessDetails.creativeDetail.promoteServices = [this.businessDetails.category.displayName];
            newBusinessDetails.services = [this.businessDetails.category.displayName];
          }
          else{
            newBusinessDetails.creativeDetail.promoteServices = [this.businessType.text];
            newBusinessDetails.services = [this.businessType.text];
          }
        }

        await this.redirect({ isAppFlow: true }, { isAppFlow: true, ...this.$route.params }, false, launchState.BusinessDetailsSetupAnimationV2, newBusinessDetails);
        this.isLoading = true;
      }
      catch(error){
        this.isLoading = false;
        Bugsnag.notify(error);
      }
    },
    validateBusinessName(value) {
      // this is regex for emoji detection. https://stackoverflow.com/questions/10992921/how-to-remove-emoji-code-using-javascript
      if (
        !value.match(
          /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g
        )
      ) {
        return true;
      }
      return false;
    },
    updateBusinessType(value){
      this.businessType = value;
      if(value.value.presetData && value.value.presetData.promotionCopy){
        this.promotionCopy = value.value.presetData.promotionCopy;
      }
      else{
        this.promotionCopy = `Best ${value.value.displayName}`;
      }
    }
  },
  async mounted(){
    if(this.isInAppCampaign){
      let newBusinessDetails = JSON.parse(JSON.stringify(this.businessDetails))
      if(newBusinessDetails){
        newBusinessDetails.launchState = launchState.BusinessDetailsV2;
        let patchBusinessDetailsPayload = {
          sessionId: this.businessDetails.sessionId,
          oldBusinessDetails: this.businessDetails,
          newBusinessDetails: newBusinessDetails
        };
        await this.patchBusinessDetails(patchBusinessDetailsPayload);
        await apiService.updateRoimaticCampaign(this.businessProfileId, this.roimaticCampaignId, this.businessDetails.sessionId);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
</style>